module.exports = __webpack_public_path__ + "static/media/evs-img.80f08d13.png";